//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import { createSelector } from 'reselect';

import { IInstagramUsedHashtag } from '@apis/instagram-hashtags-usage/instagramHashtagsUsageApiModels';
import { ICuralateStore } from '@models/AppState';

// Gets all used hashtags that are contributing to the 30 hashtag API limit
export const getUsedHashtagsLowercase = createSelector(
  (state: ICuralateStore) => state.instagramHashtagLimits.trackedHashtags,
  (state: ICuralateStore) => state.instagramHashtagLimits.otherUsedHashtags,
  (trackedHashtags, otherUsedHashtags) => {
    return [
      ...(trackedHashtags.map((usedHashtag: IInstagramUsedHashtag) => usedHashtag.hashtag.toLowerCase())),
      ...(otherUsedHashtags.map((usedHashtag: IInstagramUsedHashtag) => usedHashtag.hashtag.toLowerCase())),
    ];
  },
);

export default getUsedHashtagsLowercase;
